"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _compositionsTabs = _interopRequireDefault(require("@eig-builder/compositions-tabs"));

var _wrapperContext = _interopRequireDefault(require("../context/wrapper-context"));

var _includes = _interopRequireDefault(require("lodash/includes"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var NavbarTabs = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(NavbarTabs, _Component);

  var _super = _createSuper(NavbarTabs);

  function NavbarTabs() {
    var _this;

    (0, _classCallCheck2["default"])(this, NavbarTabs);
    _this = _super.call(this);
    _this.state = {};

    _this.getParams = function (tab) {
      var path = _this.context.location.pathname;
      var pathArray = path.split('/');
      var editComponent = (0, _includes["default"])(pathArray, 'edit-component');
      var params = {};

      if (tab.pattern) {
        var patternArray = tab.pattern.split('/');
        patternArray.forEach(function (value, index) {
          if (value.startsWith(':')) {
            params[value.substring(1)] = pathArray[index];
          }

          return false;
        });
        return params;
      }

      if (editComponent) {
        params = {
          id: pathArray[3],
          appVersionId: pathArray[5] && pathArray[5].length > 30 ? pathArray[5] : '',
          componentId: pathArray[4]
        };
      } else {
        params = {
          id: pathArray[3],
          appVersionId: pathArray[4] && pathArray[4].length > 30 ? pathArray[4] : '',
          componentId: pathArray[5]
        };
      }

      return params;
    };

    _this.getPath = function (tab) {
      if (typeof tab.path === 'function') {
        return tab.path(_this.getParams(tab));
      }

      return tab;
    };

    _this.onTabChange = function (e, tabIndex) {
      var tabs = _this.context.tabs;

      var tab = _this.getPath(tabs[tabIndex]);

      _this.context.setCurrentTab(tabIndex);

      _this.context.history.push(tab.location ? tab.location(_this.context.match.params) : tab.path);
    };

    _this.onTabChange = _this.onTabChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(NavbarTabs, [{
    key: "render",
    value: function render() {
      var _this$context = this.context,
          tabs = _this$context.tabs,
          currentTab = _this$context.currentTab;
      var isTop = this.props.isTop;
      return tabs.length > 0 && /*#__PURE__*/_react["default"].createElement(_compositionsTabs["default"], {
        onTabChange: this.onTabChange,
        currentTab: currentTab,
        tabs: tabs,
        rootClassName: "navbar-container-tabs",
        dataElementLocation: _taggingHelper.DataElementLocations.NAV,
        dataElementLabelPrefix: "navigation-tabs",
        dataElementIdPrefix: "navigation-tabs",
        isTop: isTop
      });
    }
  }]);
  return NavbarTabs;
}(_react.Component);

NavbarTabs.contextType = _wrapperContext["default"];
NavbarTabs.propTypes = {
  isTop: _propTypes["default"].bool
};
var _default = NavbarTabs;
exports["default"] = _default;